import { Theme, createStyles, makeStyles } from '@material-ui/core'
import MuiAccordion, {
  AccordionProps as Props
} from '@material-ui/core/Accordion'
import MuiAccordionActions, {
  AccordionActionsProps as PropsAccordionActions
} from '@material-ui/core/AccordionActions'
import MuiAccordionDetails, {
  AccordionDetailsProps as PropsAccordionDetails
} from '@material-ui/core/AccordionDetails'
import MuiAccordionSummary, {
  AccordionSummaryProps as PropsAccordionSummary
} from '@material-ui/core/AccordionSummary'
import * as React from 'react'

import Box from '../base/Box'
import Color from '../base/Color'
import Typography from '../base/Typography'
import Icon from '../icons/Icons'

export type AccordionProps = {
  title?: string
  content?: React.ReactNode
} & Props &
  PropsAccordionSummary

export type AccordionDetailsProps = PropsAccordionDetails
export type AccordionActionsProps = PropsAccordionActions

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      background: theme.palette.common.white,
      width: '100%',
      borderRadius: '8px 8px 0px 0px'
    },
    expandIcon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      background: Color.primary[400],
      height: 24,
      width: 24
    }
  })
)

export const AccordionDetails = MuiAccordionDetails
export const AccordionActions = MuiAccordionActions

export const Accordion: React.FC<AccordionProps> = (props) => {
  const { title, content, ...rest } = props
  const { ...summary } = props
  const classes = useStyles()
  return (
    <MuiAccordion square className={classes.root} {...rest}>
      <MuiAccordionSummary
        expandIcon={
          <Box className={classes.expandIcon}>
            <Icon iconName="ArrowBottomIcon" size="small" />
          </Box>
        }
        {...summary}
      >
        <Typography
          bodyVariants="mdBold"
          children={title ? title : 'Accordion'}
        />
      </MuiAccordionSummary>
      {content}
    </MuiAccordion>
  )
}
